import { Label, Text, type TypeLabelProps } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './ModalLabelValueRow.module.scss';

const ModalLabelValueRow = ({
  label,
  value,
  tooltip,
  alignItems = 'center',
  className,
  preserveWhitespace = false,
}: {
  label: string;
  value: React.ReactNode;
  tooltip?: TypeLabelProps['tooltip'];
  alignItems?: 'center' | 'start';
  className?: string;
  /** 값의 연속·앞뒤 공백과 줄바꿈을 원본 그대로 노출한다(기본 false). string 값에만 적용된다. */
  preserveWhitespace?: boolean;
}) => {
  return (
    <div className={clsx(styles['row-container'], styles[`align-items-${alignItems}`], className)}>
      <Label className={styles['label']} title={label} tooltip={tooltip} />
      {typeof value === 'string' ? (
        <Text
          className={clsx(styles['value'], preserveWhitespace && styles['value-preserve-whitespace'])}
          size="large"
          element="span"
        >
          {value || '-'}
        </Text>
      ) : (
        <div className={styles['value']}>{value}</div>
      )}
    </div>
  );
};

export default ModalLabelValueRow;
